// Editorial Noir — Social Post design #5.
//
// Ported from the Claude Design "Fashion - Social Post" bundle
// (fashion-posts.jsx PostNoir). Renders at fixed 1080×1080.
//
// Visual: warm-cream canvas, Bodoni Moda serif masthead + headline,
// JetBrains Mono meta lines, two-column body with roman-numeral specs
// and a captioned product card.

import type { SocialPostSlots } from '@/lib/api';
import './PostNoir.css';

interface PostNoirProps {
  slots: SocialPostSlots;
  productImageUrl: string;
}

export default function PostNoir({ slots, productImageUrl }: PostNoirProps) {
  return (
    <div className="post-noir">
      <div className="frame-pad">
        <div className="top">
          <div className="masthead">{slots.brand_name || ''}</div>
          <div className="issue">
            <span>{slots.issue_label || ''}</span>
          </div>
          <div className="eyebrow">{slots.eyebrow}</div>
        </div>
        <div className="mid">
          <div className="left">
            <div>
              <h1 dangerouslySetInnerHTML={{ __html: slots.headline }} />
              <div className="sub">{slots.subhead}</div>
            </div>
            <ul className="bullets">
              <li><span className="n">i.</span><span>{slots.bullet1}</span></li>
              <li><span className="n">ii.</span><span>{slots.bullet2}</span></li>
              <li><span className="n">iii.</span><span>{slots.bullet3}</span></li>
            </ul>
          </div>
          <div className="right">
            <div className="product">
              {productImageUrl ? (
                <img src={productImageUrl} alt="Product" />
              ) : (
                <div className="empty-state">Product image</div>
              )}
            </div>
            <div className="product-caption">
              <span>{slots.caption_left || ''}</span>
              <span className="num">{slots.caption_right || ''}</span>
            </div>
          </div>
        </div>
        <div className="bot">
          <div className="handle">FOLLOW · <span>{slots.handle}</span></div>
          <div className="badge">
            <span className="stars">{slots.badge_stars}</span>
            <span>{slots.badge_text}</span>
          </div>
          <div className="cta">{slots.cta} →</div>
        </div>
      </div>
    </div>
  );
}
